module.exports = __webpack_public_path__ + "static/media/47572565_276722236216252_8705208537812303872_n_edited.911f2f01.jpg";